function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".invoicea{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1547.221 -5671.627)"
}, /*#__PURE__*/React.createElement("path", {
  className: "invoicea",
  d: "M1569.089,5689.113h7.794a.868.868,0,1,0,0-1.736h-7.794a.868.868,0,1,0,0,1.736Z",
  transform: "translate(-14.765 -11.074)"
}), /*#__PURE__*/React.createElement("path", {
  className: "invoicea",
  d: "M1558.589,5704.863H1569.5a.868.868,0,1,0,0-1.736h-10.911a.868.868,0,1,0,0,1.736Z",
  transform: "translate(-7.383 -22.148)"
}), /*#__PURE__*/React.createElement("path", {
  className: "invoicea",
  d: "M1568.732,5675.233a1.59,1.59,0,0,0-1.159-.489h-1.47v-1.47a1.669,1.669,0,0,0-1.648-1.648h-15.587a1.669,1.669,0,0,0-1.648,1.648v18.7a1.668,1.668,0,0,0,1.648,1.647h1.47v1.47a1.669,1.669,0,0,0,1.648,1.648h15.587a1.669,1.669,0,0,0,1.648-1.648v-18.7A1.59,1.59,0,0,0,1568.732,5675.233Zm-16.657,18.394h12.381a1.668,1.668,0,0,0,1.648-1.647v-15.5h1.381v18.527h-15.409Zm12.292-20.263v18.527h-15.409v-18.527Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "invoicea",
  d: "M1558.589,5725.863H1569.5a.868.868,0,1,0,0-1.736h-10.911a.868.868,0,1,0,0,1.736Z",
  transform: "translate(-7.383 -36.913)"
}), /*#__PURE__*/React.createElement("path", {
  className: "invoicea",
  d: "M1558.589,5715.363H1569.5a.868.868,0,1,0,0-1.736h-10.911a.868.868,0,1,0,0,1.736Z",
  transform: "translate(-7.383 -29.53)"
}));

var SvgInvoice = function SvgInvoice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25.118,
    viewBox: "0 0 22 25.118",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invoice.33dd2005.svg";
export { ForwardRef as ReactComponent };